module.exports = __webpack_public_path__ + "media/customizations/caldwellcommunities/back-b0235a5e7a07da30ba9353bea1ae92cb.jpg";